export default "__VITE_ASSET__BJT$GajL__"